module.exports = __webpack_public_path__ + "media/images/sp/plans/search_form/location_type_both_location_3column-af4d04f8b7fbd999b8a983c3f2613616.webp";